import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Masonry from 'react-masonry-component';
import Shoutout from '../../components/Shoutout';
import { COLORS } from '../../styles';
import { getShoutoutById } from '../../actions/ShoutoutsActions';
import { updateShoutoutFilter } from '../../actions/ProfileActions';
import './ProfileShoutouts.scss';
import { Modal, Comments, DotLoader } from '../../components';
import ShoutoutNotFoundModal from '../../components/ShoutoutNotFoundModal';
import { Menu, MenuItem, Icon } from '@material-ui/core';
import { showToast, hideToast } from '../../actions/ToastActions';
import { PrismButton } from '../../components';

class ProfileShoutouts extends Component {
  constructor() {
    super();
    this.scrollListener = this.scrollListener.bind(this);
  }

  state = {
    showComments: null,
    menuOpen: false,
    showError: false
  };

  filterOptions = null
  preventLoading = false;
  waitingForShoutout = false;
  gallery = null;
  backToTopStartHeight = window.innerHeight * 2;

  // Needs to be a fat arrow function for proper binding and removing of the listener
  scrollListener = () => {
    let toTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (toTop + document.documentElement.clientHeight > document.body.clientHeight - 80) {
      if (!this.preventLoading) {
        this.preventLoading = true;
        setTimeout(() => {
          this.props.onShoutoutsScrolledToEnd();
          setTimeout(() => this.preventLoading = false, 1000);
        }, 2000);
      }
    }


    if (toTop > this.backToTopStartHeight && !this.props.shown) {
      const toastContent = this.renderBackToTop();
      this.props.showToast(toastContent, null, false);
    } else if (toTop <= this.backToTopStartHeight && this.props.shown) {
      this.props.hideToast();
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.scrollListener);
    document.addEventListener('keyup', this.closeCommentOnKey.bind(this));
  }

  componentWillUnmount() {
    if (this.scrollListener) {
      document.removeEventListener('scroll', this.scrollListener);
    }
    document.removeEventListener('keyup', this.closeCommentOnKey);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const id = nextProps.match.params.shoutout;
    if (id && nextProps.shoutouts.length) {
      let shoutout = nextProps.shoutouts.filter(shoutout => shoutout._id === id);

      if (shoutout.length > 0) {
        this.setState({ showComments: shoutout[0] });
      } else if (!this.waitingForShoutout) {

        this.waitingForShoutout = true;
        this.gettingShoutout(id);
        shoutout = nextProps.shoutouts.filter(shoutout => shoutout._id === id);
        if ((!shoutout || !shoutout.length) && id !== undefined) this.setState({ showError: true });

      } else if (nextProps.singleNotReturned){
        this.props.history.push(`/profile/${this.props.match.url.split('/')[2]}/shoutouts`);
      }
    } else {
      this.setState({ showComments: null });
    }
  }

  async gettingShoutout(id) {
    this.props.getShoutoutById(id, this.props.match.url.split('/')[2]);

  }

  closeCommentOnKey(e) {
    const { showComments } = this.state;
    const { history } = this.props;
    if (e.key === 's' && e.target.tagName !== 'TEXTAREA') {
      if (history.location.pathname.split('/')[1] === 'profile' && showComments) {
        this.setState({ showComments: null });
        history.push(`/profile/${history.location.pathname.split('/')[2]}/shoutouts`);
      }
    }
  }

  updateFilter(filter){
    this.setState({ menuOpen: false });
    this.props.updateShoutoutFilter(filter);
  }

  renderBackToTopContent(){
    if (window.innerWidth <= 480) {
      return (
        <div>
          <Icon>play_arrow</Icon>
          <div className="back-to-top-text">Top</div>
        </div>
      );
    }
    else {
      return (
        <div>
          <Icon>play_arrow</Icon>
          <div className="back-to-top-text">Back to top</div>
        </div>
      );
    }
  }

  renderBackToTop() {
    return (
      <div onClick={() => {
        if (document.documentElement.scrollTop !== 0) document.documentElement.scrollTop = 0;
        if (document.body.scrollTop !== 0) document.body.scrollTop = 0;
      }}
      className="back-to-top-content">
        {this.renderBackToTopContent()}
      </div>
    );
  }


  renderShoutouts() {
    const { shoutouts, history, match } = this.props;

    return (
      shoutouts.map((shoutout, i) => {
        let url = match.url;
        url = match.url[match.url.length - 1] === '/' ? url + shoutout._id : `${url}/${shoutout._id}`;
        return (
          <Shoutout
            key={shoutout.date}
            shoutout={shoutout}
            color={COLORS[i % COLORS.length]}
            commentClick={() => history.push(url)}
          />
        );
      })
    );
  }

  renderLoader() {
    const { allShoutoutsLoaded, shoutouts, firstName, onSendClick, isMe } = this.props;
    if (allShoutoutsLoaded && shoutouts.length === 0) {
      return (
        <div className="all-loaded">
          {!isMe ?
            <div>
              <p style={{ marginBottom: 15 }}>Oh no! {firstName} doesn't have any shoutouts.</p>
              <img alt="dissapointed" src={require('../../assets/img/disappointed-emoji.png')} width="57" height="57"></img>
              <p style={{ marginTop: 15 }}>Why don't you <strong onClick={onSendClick}>send one</strong>?</p>
            </div>
            :
            <div>
              <p style={{ marginBottom: 15 }}>Oh no! You don't have any shoutouts.</p>
              <img alt="self dissapointed" src={require('../../assets/img/disappointed-emoji.png')} width="57" height="57"></img>
            </div>
          }
        </div>
      );
    }
    if (allShoutoutsLoaded) {
      return (
        <div className="all-loaded">
          NO MORE SHOUTOUTS TO LOAD
        </div>
      );
    }
    return <DotLoader label="LOADING MORE SHOUTOUTS" />;
  }

  renderFilter(){
    if (window.innerWidth <= 480){
      return (
        <div className="filter-mobile" ref={(ref) => this.filterOptions = ref}>
          View Shoutouts:
          <PrismButton className="filter-mobile" onClick={() => this.setState({ menuOpen: true })}>
            <span style={{ fontWeight: 200 }}>{this.props.shoutoutFilter}</span>
          </PrismButton>
          <Menu className="profile-menu-element"
            anchorEl={this.filterOptions}
            open={this.state.menuOpen}
            onClose={() => this.setState({ menuOpen: false })}>
            <MenuItem onClick={() => this.updateFilter('Received')}>
              Received
            </MenuItem>
            <MenuItem onClick={() => this.updateFilter('Sent')}>
              Sent
            </MenuItem>
            <MenuItem onClick={() => this.updateFilter('Sent & Received')}>
              Sent & Received
            </MenuItem>
          </Menu>
        </div>
      );
    }
  }

  render() {
    const { showComments } = this.state;

    return (
      <div className="feed-parent" style={{ margin: 'auto' }}>
        <div className="user-shoutouts-feed-wrapper">
          {this.renderFilter()}
          <Masonry
            ref={(ref) => this.gallery = ref}
            className="gallery" // default ''
            id="gallery"
            enableResizableChildren={true}
            disableImagesLoaded={false} // default false
            options={{ gutter: 25, columnWidth: 430 }}
            updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
          >
            {this.renderShoutouts()}
          </Masonry>
        </div>
        {this.renderLoader()}
        <Modal
          header="Shoutout Comments"
          showModal={showComments}
          className="comments-modal"
          closeModal={() => this.props.history.push(`/profile/${this.props.match.url.split('/')[2]}/shoutouts`)}
          width="700px"
        >
          <Comments closeModal={() => this.props.history.push(`/profile/${this.props.match.url.split('/')[2]}/shoutouts`)} shoutout={showComments} />
        </Modal>

        <ShoutoutNotFoundModal showError={this.state.showError} onClose={() => this.setState({ showError: false })}/>
      </div>
    );
  }
}

const mapStateToProps = ({ profile, toastStore }) => {
  const { allShoutoutsLoaded, singleNotReturned, shoutoutFilter } = profile;
  const { shown } = toastStore;
  return { allShoutoutsLoaded, singleNotReturned, shoutoutFilter, shown };
};

export default withRouter(connect(mapStateToProps, { getShoutoutById, updateShoutoutFilter, showToast, hideToast })(ProfileShoutouts));



// WEBPACK FOOTER //
// ./src/screens/profile/ProfileShoutouts.js